import { stepsOrder } from './order.mjs';
import { frame, cancelFrame } from './frame.mjs';
/**
 * @deprecated
 *
 * Import as `frame` instead.
 */

var sync = frame;
/**
 * @deprecated
 *
 * Use cancelFrame(callback) instead.
 */

var cancelSync = stepsOrder.reduce(function (acc, key) {
  acc[key] = function (process) {
    return cancelFrame(process);
  };

  return acc;
}, {});
export { cancelSync, sync };